import { languageMap } from ".."

languageMap.applescript = {
	comments: {
		line: "--",
		block: ["(*", "*)"],
	},
}
